import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

// Placeholder functions for edit and delete action

export default function CustomizedDataGrid({
  rows,
  columns,
  loading,
  paginationMode,
  rowCount,
  paginationModel,
  onPaginationModelChange,
  pageSizeOptions,
}) {
  return (
    <DataGrid
    autoHeight
    rows={rows}
    columns={columns}
    loading={loading}
    // When paginationMode="server" is passed, the grid trusts rowCount /
    // paginationModel from the caller instead of paginating the `rows`
    // array itself — the caller is expected to fetch exactly one page's
    // worth of rows per request.
    paginationMode={paginationMode}
    rowCount={rowCount}
    paginationModel={paginationModel}
    onPaginationModelChange={onPaginationModelChange}
    pageSizeOptions={pageSizeOptions}
    getRowClassName={(params) =>
      params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
    }
    rowHeight={60}
    disableColumnResize
    density="standard"
    sx={{
      '& .MuiDataGrid-cell': {
        py: 1,
      },
      '& .MuiDataGrid-columnHeaders': {
        minHeight: '52px !important',
      },
      '& .MuiDataGrid-row': {
        borderBottom: '1px solid',
        borderColor: 'divider',
      },
    }}
    slotProps={{
      filterPanel: {
        filterFormProps: {
          logicOperatorInputProps: {
            variant: 'outlined',
            size: 'small',
          },
          columnInputProps: {
            variant: 'outlined',
            size: 'small',
            sx: { mt: 'auto' },
          },
          operatorInputProps: {
            variant: 'outlined',
            size: 'small',
            sx: { mt: 'auto' },
          },
          valueInputProps: {
            InputComponentProps: {
              variant: 'outlined',
              size: 'small',
            },
          },
        },
      },
    }}
  />

  );
}
